/* global geoip2 */
(function () {
	"use strict";

	/**
	 * free trial A/B testing code
	 */
	(function () {

		function whenGeoReady(cb) {
			if (window.geoip2) return cb();
			const id = setInterval(() => {
				if (window.geoip2) {
					clearInterval(id);
					cb();
				}
			}, 50);
		}

		// --- cookie helpers ---
		function helperSetCookie(name, value, days) {
			const expires = new Date(Date.now() + days * 864e5).toUTCString();
			document.cookie = name + "=" + encodeURIComponent(value)
			+ "; expires=" + expires
			+ "; path=/";
		}

		function helperGetCookie(name) {
			return document.cookie.split("; ").reduce((r, v) => {
				const parts = v.split("=");
				return parts[0] === name ? decodeURIComponent(parts[1]) : r;
			}, "");
		}

		// --- path check for free-trial-new and its children ---
		function onFreeTrialNewPage() {
			return location.pathname.startsWith("/free-trial-new/");
		}

		// --- show/hide logic ---
		function handleVisibility(isIndia) {
			document.querySelectorAll(".js-trial-a").forEach(el =>
				el.classList[isIndia ? "add" : "remove"]("!hidden")
			);
			document.querySelectorAll(".js-trial-b").forEach(el =>
				el.classList[isIndia ? "remove" : "add"]("!hidden")
			);
		}

		// --- update all trial links (only call when in India) ---
		function updateTrialLink() {
			document.querySelectorAll(".q-mobilemenu-trial").forEach(el => {
				if (el.tagName.toLowerCase() === "a") {
					el.href = '/free-trial-new/';
				}
			});
		}

		// --- main country handler + conditional redirect ---
		function handleCountry(code) {
			const isIndia = code === "IN";
			handleVisibility(isIndia);

			if (isIndia) {
				updateTrialLink();
			}
			else if (onFreeTrialNewPage()) {
				window.location.href = "/free-trial/";
			}
		}

		// --- entry point, called when geoip2.js is loaded ---
		var initGeo = function() {
			const cached = helperGetCookie("geoCode");
			if (cached) {
				handleCountry(cached);
			} else if (window.geoip2 && geoip2.country) {
				geoip2.country(
					function(resp) {
						const code = resp.country.iso_code || "";
						helperSetCookie("geoCode", code, 1);
						handleCountry(code);
					},
					function(err) {
						console.error("GeoIP2 lookup failed:", err);
						handleCountry(null);
					}
				);
			} else {
				console.error("GeoIP2 library not available");
				handleCountry(null);
			}
		};

		document.addEventListener("DOMContentLoaded", () => {
			whenGeoReady(initGeo);
		});

	})();

})();
